import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, scroll the window to the top.
 *
 * Reason: on mobile, tapping footer links (Sign in, Catalog, etc.) navigates
 * but the viewport stays scrolled at the footer, so users can't tell anything
 * happened. This is a browser-standard fix — routers don't reset scroll by
 * default, unlike full page loads.
 *
 * We use "smooth" behavior for a gentle transition on modern browsers; falls
 * back to instant on older ones. Focus is also moved to <main> for a11y.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Guard against SSR / test environments
    if (typeof window === "undefined") return;
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
